<template>
  <md-dialog :md-active.sync="isModal" :md-click-outside-to-close="false">
    <md-dialog-title>{{ isEdit ? "Edit CPT Code" : "Add New CPT Code" }}</md-dialog-title>

    <md-dialog-content>
      <div v-if="transformOrgIdToOrgName(orgId)" style="font-size: 14px;margin-bottom: 1rem;">
        Organization: {{ transformOrgIdToOrgName(orgId) }}
      </div>
      <div class="form-container">
        <md-field :class="{ 'md-error': formErrors.code }">
          <label>Code</label>
          <md-input v-model="form.code" required />
          <span class="md-error-msg" v-if="formErrors.code">{{ formErrors.code }}</span>
        </md-field>

        <md-field :class="{ 'md-error': formErrors.description }">
          <label>Description</label>
          <md-input v-model="form.description" required />
          <span class="md-error-msg" v-if="formErrors.description">{{ formErrors.description }}</span>
        </md-field>

        <md-field :class="{ 'md-error': formErrors.fee }">
          <label>Fee</label>
          <md-input v-model.number="form.fee" type="number" required />
          <span class="md-error-msg" v-if="formErrors.fee">{{ formErrors.fee }}</span>
        </md-field>

        <md-checkbox v-model="form.showInUI">Show at evaluation page</md-checkbox>
      </div>
    </md-dialog-content>

    <md-dialog-actions class="dialog-actions">
      <md-button @click="$emit('close')" :disabled="loading">
        Cancel
      </md-button>
      <md-button class="md-primary" @click="handleSubmit" :disabled="loading">
        {{ loading ? "Saving..." : (isEdit ? "Update" : "Create") }}
      </md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>

import Swal from "sweetalert2"
export default {
  name: "registerCptCode",
  props: {
    isModal: Boolean,
    isEdit: Boolean,
    currentCpt: Object,
    orgId: String
  },
  data() {
    return {
      form: {
        code: "",
        description: "",
        fee: null,
        showInUI: false,
      },
      loading: false,
      formErrors: {
        code: null,
        description: null,
        fee: null,
      },
    };
  },
  watch: {
    currentCpt: {
      immediate: true,
      handler(cpt) {
        if (this.isEdit && cpt) {
          this.form = {
            code: cpt.code,
            description: cpt.description,
            fee: cpt.fee,
            showInUI: cpt.showInUI,
          };
        } else {
          this.resetForm();
        }
      },
    },
  },
  methods: {
    transformOrgIdToOrgName(id) {
      const orgs = JSON.parse(sessionStorage.getItem("organizations")).filter((i) => i.orgId === id);
      const org = orgs[0]
      return org && org.orgName || ''
    },
    validate() {
      let valid = true;
      this.formErrors = { code: null, description: null, fee: null };

      if (!this.form.code || this.form.code.trim() === "") {
        this.formErrors.code = "Code is required";
        valid = false;
      }

      if (!this.form.description || this.form.description.trim() === "") {
        this.formErrors.description = "Description is required";
        valid = false;
      }

      if (this.form.fee === null || isNaN(this.form.fee)) {
        this.formErrors.fee = "Fee must be a number";
        valid = false;
      }

      return valid;
    },
    resetForm() {
      this.form = { code: "", description: "", fee: null };
      this.formErrors = { code: null, description: null, fee: null };
    },
    async handleSubmit() {
      if (!this.validate()) return;

      this.loading = true;

      this.form.orgId = this.orgId;

      const url = this.isEdit
        ? `${process.env.VUE_APP_URL}/cpt/${this.currentCpt.id}`
        : `${process.env.VUE_APP_URL}/cpt`;
      const method = this.isEdit ? "put" : "post";

      try {
        await this.$axios[method](url, this.form);
        this.$emit("close", true);
      } catch (error) {
        if (error.response && error.response.status === 422) {
          this.formErrors = { code: null, description: null, fee: null };

          const details = error.response.data.detail;

          for (const err of details) {
            const field = err.loc[1];
            const message = err.msg;

            if (field in this.formErrors) {
              this.formErrors[field] = message;
            }
          }
        } else {
          const details = error.response && error.response.data && error.response.data.detail;
          console.log(details);
          if (details === 'CPT with this code already exists') {
            Swal.fire({
              title: "Error",
              text: "This CPT code already exists. Please use another one.",
              icon: "error",
              confirmButtonText: "OK"
            });
          } else {
            Swal.fire({
              title: "Error",
              text: "An unexpected error occurred. Please try again later.",
              icon: "error",
              confirmButtonText: "OK"
            });
          }

        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.form-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.md-error-msg {
  font-size: 12px;
  color: red;
  margin-top: 4px;
}

.dialog-actions {
  justify-content: center;
  margin-bottom: 1rem;
}
</style>
